import { useState } from "react";
import { requestDemo } from "./clientCourseService";
import "./courses.css";

const ERROR_MAP = {
  "You are already enrolled in this course": "You're already enrolled — no demo needed!",
  "You have already submitted a demo request for this course": "You already have a demo request for this course.",
  "Course is not active": "This course is currently unavailable.",
};

const DemoRequestModal = ({ courseId, course, onSuccess, onClose }) => {
  const hasBatch    = course?.batchModeEnabled ?? true;
  const hasPersonal = course?.personalModeEnabled ?? true;

  const defaultType = hasBatch ? "BATCH" : "ONE_ON_ONE";
  const [demoType, setDemoType] = useState(defaultType);
  const [preferredSlot, setPreferredSlot] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [responseData, setResponseData] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      const body = { demoType };
      if (preferredSlot) body.preferredSlot = preferredSlot;
      if (message.trim()) body.message = message.trim();
      const res = await requestDemo(courseId, body);
      setResponseData(res.data);
      setDone(true);
    } catch (err) {
      const raw = err?.response?.data?.message || err?.response?.data || "Something went wrong.";
      setError(ERROR_MAP[raw] || String(raw));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cc-modal-overlay">
      <div className="cc-modal" style={{ maxWidth: 460, textAlign: "left" }}>

        {done ? (
          <div style={{ textAlign: "center", padding: "1rem 0" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>✅</div>
            <h2 style={{ fontSize: "1.2rem", margin: "0 0 0.5rem" }}>Demo Request Submitted!</h2>
            <p style={{ color: "#64748b", fontSize: "0.92rem", margin: "0 0 1.25rem" }}>
              We've received your request and will send you the Zoom link within 24 hours.
            </p>
            <button className="cc-btn cc-btn-primary" onClick={() => onSuccess(responseData)}>Done</button>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: "1.2rem", margin: "0 0 0.25rem" }}>Book a Free Demo</h2>
            <p style={{ color: "#64748b", fontSize: "0.88rem", margin: "0 0 1.25rem" }}>
              Try a free session before enrolling. We'll send you the Zoom link by email.
            </p>

            {error && (
              <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "0.5rem 0.75rem", borderRadius: 6, marginBottom: "0.75rem", fontSize: "0.85rem" }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "1rem" }}>
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: 600, color: "#374151", marginBottom: "0.3rem" }}>
                  Demo Type *
                </label>
                <select
                  value={demoType}
                  onChange={(e) => setDemoType(e.target.value)}
                  style={{ width: "100%", padding: "0.55rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.88rem" }}
                >
                  {hasBatch    && <option value="BATCH">Group Batch Demo</option>}
                  {hasPersonal && <option value="ONE_ON_ONE">One-on-One Demo</option>}
                </select>
              </div>

              <div style={{ marginBottom: "1rem" }}>
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: 600, color: "#374151", marginBottom: "0.3rem" }}>
                  Preferred Time Slot
                </label>
                <select
                  value={preferredSlot}
                  onChange={(e) => setPreferredSlot(e.target.value)}
                  style={{ width: "100%", padding: "0.55rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.88rem" }}
                >
                  <option value="">No preference</option>
                  <option value="MORNING">Morning (9am–12pm)</option>
                  <option value="AFTERNOON">Afternoon (12pm–5pm)</option>
                  <option value="EVENING">Evening (5pm–9pm)</option>
                </select>
              </div>

              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: 600, color: "#374151", marginBottom: "0.3rem" }}>
                  Message <span style={{ fontWeight: 400, color: "#9ca3af" }}>(optional)</span>
                </label>
                <textarea
                  rows={3}
                  maxLength={500}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Any questions or topics you'd like to cover?"
                  style={{ width: "100%", padding: "0.55rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.88rem", resize: "vertical", boxSizing: "border-box" }}
                />
                <div style={{ fontSize: "0.75rem", color: "#9ca3af", textAlign: "right" }}>{message.length}/500</div>
              </div>

              <div className="cc-modal-actions">
                <button type="button" className="cc-btn cc-btn-outline" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="cc-btn cc-btn-primary" disabled={saving}>
                  {saving ? "Submitting…" : "Submit Request"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default DemoRequestModal;
